import { Dropdown } from '@digitools/honest-ui';
import { QuickLinksIcon } from '@digitools/honest-ui/icons';
import React, { useEffect } from 'react';
import { getCustomerQuickLinks } from '../../../../api/ConfigApi';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';
import useExperience from '../../../../hooks/useExperience';
import useTranslate from '../../../../hooks/useTranslate';
const QuickLinks = ({ trackPageEvent }) => {
    const { t } = useTranslate();
    const { experience } = useExperience();
    /** Call for Configurable NavMenus - only when logged in & experience changes  **/
    const { data: quickLinks, get: triggerGetQuickLinks } = getCustomerQuickLinks(experience);
    useEffect(() => {
        triggerGetQuickLinks();
    }, [experience]);
    return (<div data-public={true}>
      {quickLinks && quickLinks.length > 0 && (<Dropdown menuLabel={t({ english: 'Quick links', spanish: 'Rapido enlace' })} menuIcon={<QuickLinksIcon />} menuItems={quickLinks.map((quickLink) => ({
                title: t(quickLink),
                as: 'link',
                url: quickLink.url,
                linkType: 'external',
                onClick: () => trackPageEvent?.('quick-links', TEALIUM_EVENT.EVENT_ACTION.LINK),
            }))}/>)}
    </div>);
};
export default QuickLinks;
